var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 15C30.9853 15 33 12.9853 33 10.5C33 8.01472 30.9853 6 28.5 6C26.0147 6 24 8.01472 24 10.5C24 12.9853 26.0147 15 28.5 15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5 23C45.9853 23 48 20.9853 48 18.5C48 16.0147 45.9853 14 43.5 14C41.0147 14 39 16.0147 39 18.5C39 20.9853 41.0147 23 43.5 23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5 42C45.9853 42 48 39.9853 48 37.5C48 35.0147 45.9853 33 43.5 33C41.0147 33 39 35.0147 39 37.5C39 39.9853 41.0147 42 43.5 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 23C14.9853 23 17 20.9853 17 18.5C17 16.0147 14.9853 14 12.5 14C10.0147 14 8 16.0147 8 18.5C8 20.9853 10.0147 23 12.5 23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 42C14.9853 42 17 39.9853 17 37.5C17 35.0147 14.9853 33 12.5 33C10.0147 33 8 35.0147 8 37.5C8 39.9853 10.0147 42 12.5 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 50C30.9853 50 33 47.9853 33 45.5C33 43.0147 30.9853 41 28.5 41C26.0147 41 24 43.0147 24 45.5C24 47.9853 26.0147 50 28.5 50Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.712 20C33.184 20 34.448 20.256 35.504 20.768C36.576 21.264 37.392 21.968 37.952 22.88C38.528 23.792 38.816 24.856 38.816 26.072C38.816 27.288 38.528 28.352 37.952 29.264C37.392 30.176 36.576 30.888 35.504 31.4C34.448 31.896 33.184 32.144 31.712 32.144H23.84V28.472H31.472C32.336 28.472 33.016 28.264 33.512 27.848C34.008 27.416 34.256 26.824 34.256 26.072C34.256 25.32 34.008 24.736 33.512 24.32C33.016 23.888 32.336 23.672 31.472 23.672H24.248L26.288 21.56V38H21.752V20H31.712Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5_3",
    x: 17.752,
    y: 20,
    width: 25.064,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.0079e62a86a6d8ad3dc5133593a7926d.svg";
export { ForwardRef as ReactComponent };